import React, { Suspense } from 'react';
import { StoreProvider } from './src/contexts/StoreContext.jsx';
import { LanguageProvider } from './contexts/LanguageContext.jsx';
import { LanguageSwitcher } from './components/LanguageSwitcher.jsx';
import { ThemeToggle } from './components/ThemeToggle.jsx';
import { Hero } from './components/Hero.jsx';
import { Stats, Features } from './components/Sections.jsx';
import { SEO } from './src/components/SEO.jsx';
import { LINKS, ICONS } from './constants.js';
import { Svg } from './components/ui.jsx';
import { Background } from './components/Background.jsx';
import { ConsentBanner } from './components/ConsentBanner.jsx';

// Below-the-fold sections are lazy-loaded
const Below = React.lazy(() => import('./components/Below.jsx'));

const enableSEO = process.env.VITE_ENABLE_SEO === 'true';

const App = () => (
  <StoreProvider>
    <LanguageProvider>
      {enableSEO && <SEO />}
      <Background />
      <div className="chrome">
        <LanguageSwitcher />
        <ThemeToggle />
        <a className="glass-pill round" href={LINKS.discord} target="_blank" rel="noopener noreferrer" aria-label="Discord"><Svg d={ICONS.discord} size={18} /></a>
      </div>
      <main>
        <Hero />
        <Stats />
        <Features />
        <Suspense fallback={null}><Below /></Suspense>
      </main>
      <ConsentBanner />
    </LanguageProvider>
  </StoreProvider>
);

export default App;
